import { palette } from './palette'

const whiteShadowRgb = '255, 255, 255'

export const shadow = {
    black: {
        small: `0 2px 10px 0 ${palette.black[100]}`,
        normal: `0 5px 25px 0 ${palette.black[100]}`,
        large: `0 20px 45px 0 ${palette.black[100]}`,
    },
    white: {
        small: `0 2px 10px 0 rgba(${whiteShadowRgb}, 0.08)`,
        normal: `0 5px 25px 0 rgba(${whiteShadowRgb}, 0.08)`,
        large: `0 20px 45px 0 rgba(${whiteShadowRgb}, 0.08)`,
    },
} as const

export type Shadow = typeof shadow
